// extracted by mini-css-extract-plugin
module.exports = {"image":"Image_image__JivUD","image__next-image":"Image_image__next-image__ajf2q"};